import { render, staticRenderFns } from "./Placements.vue?vue&type=template&id=2d20011a&scoped=true&"
import script from "./Placements.vue?vue&type=script&lang=js&"
export * from "./Placements.vue?vue&type=script&lang=js&"
import style0 from "./Placements.vue?vue&type=style&index=0&id=2d20011a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20011a",
  null
  
)

export default component.exports